import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import {
  StyledGridCol,
  StyledGridRow,
  StyledHeadingBar,
  StyledSectionBox,
} from "@/common/styles";
import UserInfoStaffGroups from "./UserInfoStaffGroups";
import { useEffect, useImperativeHandle, useState } from "react";
import StaffAdministrativeInformation from "./StaffAdministrativeInformation";
import UserInfoSecurityRulesControlling from "./UserInfoSecurityRulesControlling";
import ClientParamsDetails from "@/pages/Security/Sections/ClientParamsDetails";
import UserInfoRulesControllingAccess from "./UserInfoRulesControllingAccess";
import UserInfoCriteriaRulesControlling from "./UserInfoCriteriaRulesControlling";
import { useSelector, useDispatch } from "react-redux";
import { fetchSubmodules } from "@/apis/config/configApi";
import { Form } from "antd";
import { debounce } from "lodash";
import { setBookings } from "@/slices/bookingsSlice";
import { isNonEmptyVariable, isValidPassword } from "@/util/common_function";
import { fetchAllSecurityListOfStaff } from "@/apis/staff/staffApi";

const PoliceCentralUserInfo = ({ policeCentralUserRef }) => {
  const [form] = Form.useForm();

  useImperativeHandle(policeCentralUserRef, () => ({
    submitForm: () => form.submit(),
    resetForm: () => form.resetFields(),
    getFormValues: () => form.getFieldsValue(),
    getFieldsError: () => form.getFieldsError(),
    isFieldsValidating: () => form.isFieldsValidating(),
    validateFields: () => form.validateFields(),
    form: form,
  }));
  const [isStaffMemberCanLogin, setIsStaffMemberCanLogin] = useState(false);
  const dispatch = useDispatch();
  const onChangeLoginCheck = (e) => {
    let isChecked = e.target.checked;
    dispatch(
      setBookings({
        isPoliceCentralUser: isChecked,
      })
    );

    if (!isChecked) {
      let obj = {
        username: null,
        password: null,
        passwordLastUpdated: null,
        initialModule: null,
        initialSubmodule: null,
        securityLevel: null,
      };
      form.setFieldsValue({ ...obj });
      dispatch(
        setBookings({
          username: null,
          password: null,
          passwordLastUpdated: null,
          initialModule: null,
          initialSubmodule: null,
          securityLevel: null,
        })
      );
    }
  };

  const { bookings, bookingsFieldsEnabled } = useSelector((s) => s?.bookings);
  const moduleOptions = useSelector((state) =>
    state.config.configModules?.map((m) => ({
      value: m.moduleID,
      label: m.moduleName,
    }))
  );
  const submoduleOptions = useSelector((state) => {
    const options =
      state.config.configSubModules?.map((s) => ({
        value: s.subModuleID,
        label: s.subModuleName,
      })) || [];

    return [{ value: null, label: "" }, ...options];
  });
  // const [policeCentralUserRef] = Form.useForm();
  const [form2] = Form.useForm();
  const staff = useSelector((s) => s.staff) || [];

  useEffect(() => {
    let {
      username,
      passwordLastUpdated,
      securityLevel,
      initialModule,
      initialSubmodule,
      isPoliceCentralUser,
    } = bookings || {};
    if (bookings?.isPoliceCentralUser)
      form.setFieldsValue({
        username,
        passwordLastUpdated,
        securityLevel,
        initialModule,
        initialSubmodule,
      });
    form2.setFieldsValue({ isPoliceCentralUser });
    setIsStaffMemberCanLogin(isPoliceCentralUser);
  }, [bookings]);

  let securityLevel = [
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
  ];
  let dataChange = debounce(() => {
    let obj = form.getFieldsValue();
    // if (!isNonEmptyVariable(obj?.password)) delete obj["password"];
    dispatch(
      setBookings({
        ...bookings,
        ...obj,
      })
    );
  }, 600);

  useEffect(() => {
    if (bookings?.staffId)
      dispatch(fetchAllSecurityListOfStaff(bookings?.staffId));
  }, []);

  const handleFieldsChange = ({ target: { name, value } }) => {
    const lettersOnly = value.replace(/[^a-zA-Z0-9]/g, "");
    form.setFieldValue("username", lettersOnly);
  };

  const validatePassword = (_, value) => {
    if (!value) {
      return Promise.resolve();
    }
    if (!isValidPassword(value)) {
      return Promise.reject(
        new Error(
          "Password must be at least 12 characters long and include uppercase, lowercase, number, and special character."
        )
      );
    }
    return Promise.resolve();
  };
  return (
    <>
      <StyledSectionBox>
        <StyledHeadingBar>
          <span className="main-title">Login Information</span>
        </StyledHeadingBar>

        <div className="content">
          <Form form={form2} disabled={!bookingsFieldsEnabled}>
            <StyledGridRow>
              <StyledGridCol>
                <FormItem
                  label="This Staff Member can Login to the System"
                  labelPostion="label-right"
                  layout="horizontal"
                  name="isPoliceCentralUser"
                  valuePropName="checked"
                >
                  <Checkbox
                    value={isStaffMemberCanLogin}
                    onChange={onChangeLoginCheck}
                  />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </Form>
          {isStaffMemberCanLogin && (
            <>
              <Form
                form={form}
                onFieldsChange={dataChange}
                disabled={!bookingsFieldsEnabled}
              >
                <StyledGridRow gutter={16}>
                  <StyledGridCol lg={8}>
                    <FormItem label="User Name" name="username">
                      <TextField onChange={handleFieldsChange} />
                    </FormItem>
                  </StyledGridCol>

                  <StyledGridCol lg={8}>
                    <FormItem
                      label="Password"
                      name="password"
                      autoComplete="off"
                      rules={[{ validator: validatePassword }]}
                      hasFeedback
                    >
                      <TextField
                        inputType="password"
                        autoComplete="new-password"
                      />
                    </FormItem>
                  </StyledGridCol>

                  <StyledGridCol lg={8}>
                    <FormItem
                      label="Password Last Updated"
                      name="passwordLastUpdated"
                    >
                      <TextField disabled />
                    </FormItem>
                  </StyledGridCol>

                  <StyledGridCol lg={8}>
                    <FormItem label="Initial Module" name="initialModule">
                      <Select
                        options={moduleOptions}
                        onChange={(moduleId) => {
                          dispatch(fetchSubmodules(moduleId));
                        }}
                        disabled={!bookingsFieldsEnabled}
                      />
                    </FormItem>
                  </StyledGridCol>

                  <StyledGridCol lg={8}>
                    <FormItem label="Submodule" name="initialSubmodule">
                      <Select
                        options={submoduleOptions}
                        disabled={!bookingsFieldsEnabled}
                      />
                    </FormItem>
                  </StyledGridCol>

                  <StyledGridCol lg={8}>
                    <FormItem label="Security Level" name="securityLevel">
                      <Select
                        options={securityLevel}
                        disabled={!bookingsFieldsEnabled}
                      />
                    </FormItem>
                  </StyledGridCol>
                </StyledGridRow>
              </Form>
              <UserInfoStaffGroups
                bookingsFieldsEnabled={bookingsFieldsEnabled}
              />

              <UserInfoSecurityRulesControlling
                bookingsFieldsEnabled={bookingsFieldsEnabled}
              />

              <UserInfoRulesControllingAccess
                bookingsFieldsEnabled={bookingsFieldsEnabled}
              />

              <UserInfoCriteriaRulesControlling
                bookingsFieldsEnabled={bookingsFieldsEnabled}
              />
            </>
          )}
        </div>
      </StyledSectionBox>
      {isStaffMemberCanLogin && (
        <ClientParamsDetails
          headerSubTitle="List of Client Params for this Staff Member"
          bookingsFieldsEnabled={bookingsFieldsEnabled}
        />
      )}

      {/* <StaffAdministrativeInformation /> */}
    </>
  );
};
export default PoliceCentralUserInfo;
